"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

var _useUtils = require("../../_helpers/use-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./PageWizard.css");

var _styles = {
  "page-wizard": "PageWizard__page-wizard___17_1i",
  "header": "PageWizard__header___sepab",
  "footer": "PageWizard__footer___2Fj9k",
  "title": "PageWizard__title___2Hsya",
  "exit-link": "PageWizard__exit-link___3UiNq",
  "completed": "PageWizard__completed___3nBpu",
  "hide": "PageWizard__hide___2k6Wb",
  "footer-actions": "PageWizard__footer-actions___1hj4S",
  "steps": "PageWizard__steps___3ap5J",
  "back-button": "PageWizard__back-button___2eySB",
  "continue-button": "PageWizard__continue-button___RZcEM",
  "intro-button": "PageWizard__intro-button___yDxvi",
  "exit-button": "PageWizard__exit-button___1fv-H",
  "page-section": "PageWizard__page-section___zB6qz",
  "page-wrapper": "PageWizard__page-wrapper___30FqM",
  "page": "PageWizard__page___1_4_x",
  "show-header-footer": "PageWizard__show-header-footer___1WfRk",
  "page-exiting": "PageWizard__page-exiting___3KHUN",
  "animate": "PageWizard__animate___2J_xj",
  "is-exit-page": "PageWizard__is-exit-page___3FG0G",
  "exit-animation-triggered": "PageWizard__exit-animation-triggered___wUw0T"
};

const styles = _bind.default.bind(_styles);

const PageWizardStep = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  children
}) => {
  const composed_classname = (0, _bind.default)(styles('page'), className);
  return _react.default.createElement("div", {
    "data-testid": dataTestId,
    className: composed_classname
  }, children);
});
const PageWizard = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  children,
  title,
  onWizardCompleted,
  onExitLinkClicked,
  onStepChange,
  stepWillChange,
  canChangeStep,
  animate,
  triggerExitAnimation,
  pageExitDurationMS = 1000,
  continueLabel,
  continueDisabled,
  continueLoading,
  backLabel,
  backDisabled,
  introButtonLabel,
  introButtonDisabled,
  pageIndex,
  exitButtonLabel,
  exitButtonDisabled,
  hideFooter,
  hideExitButton
}) => {
  const introPage = _react.default.Children.toArray(children).find(child => _react.default.isValidElement(child) && child.type === PageWizardStep && child.props.isIntroPage && child.props.enabled !== false);

  const exitPage = _react.default.Children.toArray(children).find(child => _react.default.isValidElement(child) && child.type === PageWizardStep && child.props.isExitPage && child.props.enabled !== false);

  const pages = _react.default.Children.toArray(children).filter(child => {
    if (_react.default.isValidElement(child) && child.type === PageWizardStep) {
      const props = child.props;
      return props.enabled !== false && !props.isIntroPage && !props.isExitPage;
    }

    throw new Error(`PageWizard only supports the 'PageWizard.Step' component`);
  });

  const isMounted = (0, _useUtils.useIsMounted)();
  const [isCompleted, setIsCompleted] = (0, _react.useState)(false);
  const [showHeaderFooter, setShowHeaderFooter] = (0, _react.useState)(!animate);
  const [progress, setProgress] = (0, _react.useState)(0);
  const [pageExiting, setPageExiting] = (0, _react.useState)(false);
  const [showIntroPage, setShowIntroPage] = (0, _react.useState)(!!introPage && (pageIndex === undefined || pageIndex === 'intro'));
  const [showExitPage, setShowExitPage] = (0, _react.useState)(!!exitPage && pageIndex === 'exit');
  const [currentPageIndex, setCurrentPageIndex] = (0, _react.useState)(pageIndex !== undefined ? pageIndex : showIntroPage ? 'intro' : 0);
  const totalPages = pages.length;
  (0, _useUtils.useEffectOnce)(() => setShowHeaderFooter(true));
  const pageChangeRef = (0, _react.useRef)(currentPageIndex);
  (0, _react.useEffect)(() => {
    if (currentPageIndex === 'intro') {
      setProgress(0);
    } else if (currentPageIndex === 'exit') {
      setProgress(1);
    } else {
      setProgress(1 / totalPages * (currentPageIndex + 1));
    }

    if (pageChangeRef.current === currentPageIndex) {
      return;
    }

    pageChangeRef.current = currentPageIndex;
    onStepChange && onStepChange(currentPageIndex, totalPages);
  }, [currentPageIndex]);

  const renderPage = (child, index) => {
    if (index !== currentPageIndex) {
      return undefined;
    }

    return _react.default.createElement("div", {
      key: index,
      "data-testid": dataTestId && `${dataTestId}-page-${index}`,
      className: styles('page-wrapper')
    }, child);
  };

  const changeStepIndex = async nextPageIndex => {
    if (canChangeStep) {
      const canChange = await canChangeStep(currentPageIndex, nextPageIndex, totalPages);

      if (!canChange || !isMounted()) {
        return;
      }
    }

    if (animate) {
      setPageExiting(true);

      if (stepWillChange) {
        stepWillChange(currentPageIndex, nextPageIndex, totalPages);
      }

      await new Promise(resolve => setTimeout(resolve, pageExitDurationMS));

      if (isMounted()) {
        setPageExiting(false);
      } else {
        return;
      }
    }

    setShowIntroPage(nextPageIndex === 'intro');
    setShowExitPage(nextPageIndex === 'exit');
    setCurrentPageIndex(nextPageIndex);
  };

  const pageChangeFirstRun = (0, _react.useRef)(true);
  (0, _react.useEffect)(() => {
    if (pageChangeFirstRun.current) {
      pageChangeFirstRun.current = false;
    } else if (pageIndex !== undefined) {
      changeStepIndex(pageIndex);
    }
  }, [pageIndex]);
  const composed_classname = (0, _bind.default)(styles('page-wizard', {
    animate,
    'is-exit-page': showExitPage,
    'show-header-footer': showHeaderFooter,
    'page-exiting': animate && pageExiting,
    'exit-animation-triggered': triggerExitAnimation
  }), className);
  return _react.default.createElement("div", {
    "data-testid": dataTestId,
    className: composed_classname
  }, _react.default.createElement("div", {
    className: styles('header')
  }, _react.default.createElement(_.Logo, {
    height: 16
  }), title ? _react.default.createElement(_.Text, {
    className: styles('title'),
    size: 18,
    text: title
  }) : _react.default.createElement("div", null), _react.default.createElement(_.Link, {
    className: styles('exit-link', {
      completed: isCompleted,
      hide: hideExitButton
    }),
    dataTestId: dataTestId && `${dataTestId}-header-exit`,
    disableSelection: true,
    text: `Exit`,
    disabled: isCompleted || showExitPage,
    onClick: () => {
      if (onExitLinkClicked) {
        onExitLinkClicked();
      } else {
        setIsCompleted(true);
        onWizardCompleted();
      }
    }
  })), _react.default.createElement("div", {
    className: styles('page-section')
  }, showIntroPage ? renderPage(introPage, 'intro') : showExitPage ? renderPage(exitPage, 'exit') : pages.map(renderPage)), _react.default.createElement("div", {
    className: styles('footer'),
    style: {
      transform: hideFooter ? 'translateY(100%)' : ''
    },
    "data-testid": `${dataTestId}-footer`
  }, _react.default.createElement(_.ProgressBar, {
    dataTestId: dataTestId && `${dataTestId}-progress-bar`,
    className: styles('progress-bar'),
    variant: 'line',
    progress: progress,
    growthDurationMS: animate ? 1000 : undefined
  }), _react.default.createElement("div", {
    className: styles('footer-actions'),
    style: {
      transitionDuration: `${pageExitDurationMS}ms`
    }
  }, _react.default.createElement(_.Button, {
    dataTestId: dataTestId && `${dataTestId}-back-button`,
    className: styles('back-button', {
      hide: showIntroPage || showExitPage || currentPageIndex === 0 || isCompleted
    }),
    disabled: showIntroPage || showExitPage || currentPageIndex === 0 || backDisabled || isCompleted,
    label: backLabel || 'Back',
    variant: 'outlined',
    onClick: () => {
      if (typeof currentPageIndex === 'number' && currentPageIndex > 0) {
        changeStepIndex(currentPageIndex - 1);
      }
    }
  }), _react.default.createElement(_.Text, {
    dataTestId: dataTestId && `${dataTestId}-steps-label`,
    className: styles('steps', {
      hide: showIntroPage || showExitPage
    }),
    text: typeof currentPageIndex === 'number' ? `Step ${currentPageIndex + 1} of ${totalPages}` : ''
  }), _react.default.createElement(_.Button, {
    dataTestId: dataTestId && `${dataTestId}-continue-button`,
    className: styles('continue-button', {
      hide: showIntroPage || showExitPage
    }),
    disabled: showIntroPage || showExitPage || continueDisabled,
    loading: isCompleted || continueLoading,
    label: continueLabel || (currentPageIndex >= totalPages - 1 ? 'Finish' : 'Continue'),
    onClick: () => {
      if (typeof currentPageIndex === 'string') {
        return;
      }

      if (currentPageIndex >= totalPages - 1) {
        if (exitPage) {
          changeStepIndex('exit');
        } else {
          setIsCompleted(true);
          onWizardCompleted();
        }
      } else {
        changeStepIndex(currentPageIndex + 1);
      }
    }
  }), showIntroPage && _react.default.createElement(_.Button, {
    dataTestId: dataTestId && `${dataTestId}-intro-button`,
    className: styles('intro-button'),
    disabled: introButtonDisabled,
    loading: isCompleted,
    label: introButtonLabel || 'Begin',
    onClick: () => changeStepIndex(0)
  }), showExitPage && _react.default.createElement(_.Button, {
    dataTestId: dataTestId && `${dataTestId}-exit-button`,
    className: styles('exit-button'),
    disabled: exitButtonDisabled,
    loading: isCompleted,
    label: exitButtonLabel || 'Exit',
    onClick: () => {
      setIsCompleted(true);
      onWizardCompleted();
    }
  }))));
});

var _default = Object.assign(PageWizard, {
  Step: PageWizardStep
});

exports.default = _default;